import React, { Fragment, useState, useEffect } from 'react'
import { Card, Col, Container, CardBody, Row } from 'reactstrap';
import 'animate.css';
import { ModalViewExamsQuoter } from './ModalViewExamsQuoter';
import "react-datetime/css/react-datetime.css";
import './styleQuoterMic.css';
import { ModalPatientMicro } from './ModalPatientMicro';

import { DialogPreviewQuoterPdf } from './DialogPreviewQuoterPdf';
import { DialogPreviewPdfSamplingSheet } from './DialogPreviewPdfSamplingSheet';
import '../../micro/cotizacion/StyleQuoterM.css'

import 'moment/locale/es';
import { IndexPreviewQuoter } from './IndexPreviewQuoter';
import { CustomAlertModal } from '../../customMoldalAlert/CustomAlertModal';
import { TableDeterminations } from './SampleDeterminations/TableDeterminations';
import '../../micro/cotizacion/SyleQuoterMic/styleFooterMovil.css'
import { ModalNormExam } from './ModalNormExam';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { SearchClientQuoterMic } from './ComponentQuoter/SearchClientQuoterMic';
import { SearchQuoterMovil } from './ComponentsQuoterMovil/SearchQuoterMovil';
import { InformationSamplingMic } from './ComponentQuoter/InformationSamplingMic';
import { FooterQuoterMicMovil } from './ComponentsQuoterMovil/FooterQuoterMicMovil';
import { FooterQuoterMic } from './ComponentQuoter/FooterQuoterMic';

export const IndexQuoterMic = ({ typeClient = 1, setHideTabs, setActiveIndex, quoterHook }) => {

	const {

		//*TYPE CLIENT
		handleChangeTypeClient, checkTypeClient, handleChangePatient, informationPatient, listCompanies, handleChangeCompany, informationCompany,
		listAddress, handleChangeAddress,

		//*QUOTER
		handleChangeComments, handlePickerValues, handleChangeSampling,

		//*TYPE OF SAMPLE
		handleSelectDetermination, searchSampleState, examProfileState, handleSelectMuestra,

		//*FORM MIC
		formQuoterMic,

		//*ACTION TYPE SAMPE
		handleDeleteTypeSample, handleAddQuantity, handleDeleteQuantity,

		//*TABLE
		handleObservations, listRules, handleSearchRules, handleRemoveDeterminacion,

		//*TOGGLE EXAMS
		handleToggleExams, handleViewExamsProfile, modalExams, listExams,

		//*PRICES
		optionsTotal, total_tax,

		//*VIEW QUOTER
		handleViewQuoter, handleClosedQuoter, viewQuoter, nameBranch, loadingCreate,

		//*CREATE
		saveQuatation, downloadQuoter, handleNewQuatation, handleNavigateSampling,

		//*UPDATE QUOTER
		updateQuatation,

		//*CONFIGURATION BUTTONS
		isHovered, handleMouseEnter, handleMouseLeave, handleMouseEnterClean, handleMouseLeaveClean, isHoveredClean,

		//*
		informationQuatation,

		handleFilterValues, handleSearchClient,

		getFilter, handleCleanFilter,

		//*AGREEMENT
		listAgreement, handleChangeAgreement,

		// * CREATE PATIENT
		modalPatient, tooglePatient, formPatient, handleInformationPatient, savePatient, loadingPatientMicro,errorsPatient, 

		url_helen,

		//* PDF QUOTER PREVIEW
		setShowPreviewPdfQuoter, showPreviewPdfQuoter, pdfPreviewQuoter, loadingPdfQuoter,

		//* PDF Sampling Sheet
		showPreviewSamplingSheet, setShowPreviewSamplingSheet, setPdfPreviewSamplingSheet, pdfPreviewSamplingSheet,
		handleDownloadPdf, loadingPdf, currentCode, currentQuoter,

		//* MODAL ALERT NOM
		showAlertNorma, setShowAlertNorma, messageNorma,

		//* COUNT NUMBER TABLE 
		handleChangeQuantity,

		//* DIALOG NORMS
        handleViewNorms,detailNorm, modalNorms, handleToggleNorms,

    	//* DELETE SAMPLE
        openDeleteSampleAlert, saveDeleteSample, closeDeleteAlert, showDeleteAlert, modalAlert, sampleDeleteName,

		//* DELETE DETERMINATION
		openDeleteDeterminacionAlert, saveDeleteDeterminacion, deleteType, detDeleteData,

		//* COUNT SAMPLE AND DETERMINATIONS
        totalSample, totalDeterminations,

		handleGoBack
		

	} = quoterHook;
	
	const [footerOpen, setFooterOpen] = useState(false);
	useEffect(() => {

		if (formQuoterMic.id_quatation > 0) {
			return;
		}

		handleChangeTypeClient(typeClient, true);

	}, [typeClient]);

	const isClientSelected =
		(checkTypeClient === 1 && formQuoterMic.id_patient) ||
		(checkTypeClient === 3 &&
			formQuoterMic.id_company &&
			formQuoterMic.id_agreement);

	const hasDeterminations = formQuoterMic.list_type_samples.length > 0 &&
		formQuoterMic.list_type_samples.some(sample =>
			sample.list_determinations && sample.list_determinations.length > 0
		);

	if (viewQuoter) {
		return (
			<IndexPreviewQuoter
				viewQuoter={viewQuoter}
				checkTypeClient={checkTypeClient}
				informationCompany={informationCompany}
				loadingCreate={loadingCreate}
				formQuoterMic={formQuoterMic}
				informationPatient={informationPatient}
				nameBranch={nameBranch}
				downloadQuoter={downloadQuoter}
				updateQuatation={updateQuatation}
				saveQuatation={saveQuatation}
				handleNavigateSampling={handleNavigateSampling}
				handleClosedQuoter={handleClosedQuoter}
				handleFilterValues={handleFilterValues}
				listCompanies={listCompanies}
				handleSearchClient={handleSearchClient}
				isHoveredClean={isHoveredClean}
				isHovered={isHovered}
				getFilter={getFilter}
				handleCleanFilter={handleCleanFilter}
				handleMouseEnterClean={handleMouseEnterClean}
				handleMouseEnter={handleMouseEnter}
				handleMouseLeaveClean={handleMouseLeaveClean}
				handleMouseLeave={handleMouseLeave}
				total_tax={total_tax}
				optionsTotal={optionsTotal}
				handleNewQuatation={handleNewQuatation}
				handleViewQuoter={handleViewQuoter}
				handleChangeTypeClient={handleChangeTypeClient}
				handleGoBack={handleGoBack}
			/>
		);
	}

	return (
		<Fragment>
				<div className="quoter-ios">
					<Row>
						{
							//* SEARCH DESKTOP
						}
						<Col lg="12" className="d-none d-md-block">
							<Card className="company-banner-card">
								<CardBody>
									<SearchClientQuoterMic
									{
										...{
											checkTypeClient, tooglePatient, formQuoterMic, handleChangePatient, 
											listCompanies, handleChangeCompany, handleChangeAgreement, listAgreement,
											informationPatient, informationCompany
										}
									}
									/>
									
								</CardBody>
							</Card>
						</Col>

						{
							//* SEARCH MOVIL
						}

						<Col xs="12" className="d-block d-md-none">

							<Card className="company-banner-card">
								<CardBody>
									<SearchQuoterMovil
										{
											...{
												checkTypeClient, tooglePatient, formQuoterMic, handleChangePatient, 
												listCompanies, handleChangeCompany, handleChangeAgreement, listAgreement,
												informationCompany, informationPatient
											}
										}
									/>

								</CardBody>
							</Card>
						</Col>

						{
							//* SECCTIONS SAMPLING
						}

						<Col lg="3">
							<InformationSamplingMic 
								{
									...{
										isClientSelected, formQuoterMic, handleChangeSampling, url_helen,
										checkTypeClient, handlePickerValues, handleChangeAddress, listAddress,
										handleChangeComments

									}
								}
							/>
						</Col>

						{
							//* TABLE DETERMINATIONS AND SAMPLE
						}

						<Col lg="9">
							<TableDeterminations
								isClientSelected={isClientSelected}
								formQuoterMic={formQuoterMic}
								handleSelectMuestra={handleSelectMuestra}
								searchSampleState={searchSampleState}
								handleSelectDetermination={handleSelectDetermination}
								examProfileState={examProfileState}
								handleDeleteQuantity={handleDeleteQuantity}
								handleAddQuantity={handleAddQuantity}
								handleViewExamsProfile={handleViewExamsProfile}
								url_helen={url_helen}
								handleSearchRules={handleSearchRules}
								listRules={listRules}
								handleRemoveDeterminacion={handleRemoveDeterminacion}
								handleDeleteTypeSample={handleDeleteTypeSample}
								handleChangeQuantity={handleChangeQuantity}
								checkTypeClient={checkTypeClient}
								handleObservations={handleObservations}
								handleViewNorms={handleViewNorms }
								openDeleteSampleAlert={openDeleteSampleAlert}
								openDeleteDeterminacionAlert={openDeleteDeterminacionAlert}
							/>
						</Col>

					</Row>



				</div>


			

			{
				//* FOOTER DESKTOP
			}
			
			<FooterQuoterMic
				{
					...{
						optionsTotal, total_tax, viewQuoter,
						formQuoterMic, handleChangeTypeClient, setActiveIndex,
						setHideTabs, hasDeterminations, handleViewQuoter, handleClosedQuoter,
						totalSample, totalDeterminations
    
					}
				}
			/>


			{
				//* FOOTER MOVIL
			}

			<FooterQuoterMicMovil
				{
					...{
						setFooterOpen, footerOpen, optionsTotal, total_tax, viewQuoter,
						formQuoterMic, handleChangeTypeClient, setActiveIndex,
						setHideTabs, hasDeterminations, handleViewQuoter, handleClosedQuoter
					}
				}
			/>


			<ModalViewExamsQuoter
				{
				...{ modalExams, handleToggleExams, listExams }
				}
			/>
			<ModalPatientMicro
				{
				...{ modalPatient, tooglePatient, formPatient, handleInformationPatient, savePatient, loadingPatientMicro, errorsPatient }
				}

			/>

			<DialogPreviewQuoterPdf
				pdfPreviewQuoter={pdfPreviewQuoter}
				showPreviewPdfQuoter={showPreviewPdfQuoter}
				setShowPreviewPdfQuoter={setShowPreviewPdfQuoter}
				loadingPdfQuoter={loadingPdfQuoter}
				downloadQuoter={downloadQuoter}
				informationQuatation={informationQuatation}
			/>

			<DialogPreviewPdfSamplingSheet
				{
				...{
					showPreviewSamplingSheet, setShowPreviewSamplingSheet, setPdfPreviewSamplingSheet, pdfPreviewSamplingSheet, handleDownloadPdf, informationQuatation, loadingPdf,
					currentCode, currentQuoter
				}
				}
			/>

			<CustomAlertModal
				visible={showAlertNorma}
				title="Norma requerida"
				message={messageNorma}
				icon="fa fa-exclamation-triangle"
				buttonText="Aceptar"
				onAccept={() => setShowAlertNorma(false)}
			/>


			<ModalNormExam
				modalExams={modalNorms}
				handleToggleExams={handleToggleNorms}
				detailNorm={detailNorm}
			/>
			{showDeleteAlert && (
				<AlertDataTable
					titleAlert={
						deleteType === "sample"
							? "Eliminar muestra"
							: "Eliminar determinación"
					}
					visibleAlert={modalAlert}
					onHideAlert={closeDeleteAlert}
					sizeAlert="medium-dialog delete-method"
					messageAlert={
						deleteType === "sample"
							? "Esta acción eliminará la muestra y todas sus determinaciones asociadas. ¿Deseas continuar?"
							: "Esta acción no se puede deshacer. ¿Estás seguro de eliminar la determinación?"
					}
					alert1={true}
					titleAlert1={
						deleteType === "sample"
							? sampleDeleteName
							: detDeleteData.name
					}
					buttonAcept
					titleNotLoading="Eliminar"
					titleDanger="Cancelar"
					actionAcept={
						deleteType === "sample"
							? saveDeleteSample
							: saveDeleteDeterminacion
					}
				/>
			)}



		</Fragment >

	)
}
